<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-08-24 14:45:18
 * @Description: 
-->
<template>
  <Drawer
    width="400"
    :title="`${openedSac ? '编辑' : '新增'}SAC公司`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EditSACCompanyDrawer",
  components: {},
  props: {},
  data() {
    return {
      drawerOpened: false,
      openedSac: null,
      formItem: {
        name: null,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "blur" }],
      },
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      createSacCompany: "sacCompany/createSacCompanyAction",
      updateSacCompany: "sacCompany/updateSacCompanyAction",
    }),
    openDrawer(sac) {
      this.$refs["formItem"].resetFields();
      this.openedSac = sac;
      if (sac) {
        this.formItem.name = this.openedSac.name;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSac) {
              await this.updateSacCompany({
                id: this.openedSac._id,
                data: this.formItem,
              });
            } else {
              await this.createSacCompany(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
